import { Modal } from 'antd'
import Styles from './UnsavedChangesConfirmModal.module.scss'
import { UnsavedChangesConfirmModalProps } from './Types'
import { Button } from 'components/Button'

const UnsavedChangesConfirmModal = ({ onCancel, onConfirm }: UnsavedChangesConfirmModalProps) => {
  return (
    <Modal visible wrapClassName={Styles.container} closable={false} footer={null} width={560}>
      <div className={Styles.header}>You have unsaved changes</div>
      <div className={Styles.body}>
        <p>Are you sure you want to leave?</p>
      </div>
      <div className={Styles.footer}>
        <Button variant="tertiaryGreen" size="lg" onPress={onCancel}>
          Go back
        </Button>

        <Button size="lg" onPress={onConfirm}>
          Yes I'm sure
        </Button>
      </div>
    </Modal>
  )
}

export { UnsavedChangesConfirmModal }
